import script from "./empty.vue?vue&type=script&setup=true&lang=js"
export * from "./empty.vue?vue&type=script&setup=true&lang=js"

import "./empty.vue?vue&type=style&index=0&id=279264e8&scoped=true&lang=css"

import exportComponent from "/var/www/html/koboeat/test/customer_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-279264e8"]])

export default __exports__